const logError = (error) => {
  if (window.dtrum) {
    window.dtrum.reportError(error)
  }
}

const logCustomError = (key, value) => {
  if (window.dtrum) {
    window.dtrum.reportCustomError(key, value)
  }
}

export { logCustomError, logError }
